<div class="checkbox-comp">
  <label for="{{id}}">
    <span class="text-sm font-primary text-grey-900 zui-content label-text" [ngClass]="labelPosition" *ngIf="label && labelPosition !== 'right'">{{label}}</span>
    <input type="checkbox" id="{{id}}" [disabled]="disabled" [(ngModel)]="value" class="zui-checkbox icon mt-1" [ngClass]="{'not-selected': intermediateState, 'unchecked': !value && !intermediateState, 'checked': value && !intermediateState}" />
    <span class="text-sm font-primary text-grey-900 zui-content label-text" *ngIf="label && labelPosition === 'right'">{{label}}</span>
  </label>
</div>
